import { Link } from "wouter";

const PPC_GUIDE_PATH = "/google-ads-optimization-ppc-performance/";

export default function PPCOptimisationGuideLink() {
  return (
    <section className="mt-10 border border-teal-300/20 bg-teal-300/[0.04] p-5 sm:p-6" aria-labelledby="ppc-optimisation-guide-link">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-teal-300">Primary guide</p>
      <h2 id="ppc-optimisation-guide-link" className="font-serif text-xl text-white">
        Improve Google Ads Results: 7 PPC Optimisation Steps (UK)
      </h2>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-300">
        Use the practical diagnostic sequence for conversion tracking, search intent, match types, AI Max, responsive search ads, landing pages, bidding and incrementality.
      </p>
      <Link href={PPC_GUIDE_PATH} className="mt-4 inline-flex text-sm font-semibold text-teal-300 hover:text-teal-200">
        Read the Google Ads optimisation guide →
      </Link>
    </section>
  );
}
